import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

import _ from "lodash";
import { init, reInit } from "./tiny-slider";
import {
  TinySliderInstance,
  TinySliderSettings,
} from "tiny-slider/src/tiny-slider";
import { HTMLAttributes, ref, onMounted, inject } from "vue";

export interface TinySliderElement extends HTMLDivElement {
  tns: TinySliderInstance;
}

export type ProvideTinySlider = (el: TinySliderElement) => void;

export interface TinySliderProps extends HTMLAttributes {
  refKey?: string;
  options?: TinySliderSettings;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TinySlider',
  props: {
    refKey: null,
    options: null
  },
  setup(__props: any) {

const props = __props as {
  refKey?: string;
  options?: TinySliderSettings;
}



const sliderRef = ref<TinySliderElement>();

const bindInstance = (el: TinySliderElement) => {
  if (props.refKey) {
    // eslint-disable-next-line
    const bind = inject<ProvideTinySlider>(`bind[${props.refKey}]`, () => {});
    if (bind) {
      bind(el);
    }
  }
};

const vSliderDirective = {
  mounted(el: TinySliderElement) {
    init(el, props);
  },
  updated(el: TinySliderElement) {
    reInit(el);
  },
};

onMounted(() => {
  if (sliderRef.value) {
    bindInstance(sliderRef.value);
  }
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "tiny-slider",
    ref_key: "sliderRef",
    ref: sliderRef
  }, [
    _renderSlot(_ctx.$slots, "default")
  ])), [
    [vSliderDirective]
  ])
}
}

})